export default "__VITE_ASSET___yyscca6__"